var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex flex-column justify-center align-center",attrs:{"cols":"12"}},[_c(_setup.Spinner,{attrs:{"color":_vm.color}}),(_vm.text)?_c('p',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }